import { createContext } from 'react';


const MarkerContext = createContext();
const { Provider } = MarkerContext;

export { Provider };
export default MarkerContext;
